import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsPortalViewsCountByTimeTab = _resolveComponent("StatisticsPortalViewsCountByTimeTab")!
  const _component_StatisticsPortalViewsCountByNavigationTab = _resolveComponent("StatisticsPortalViewsCountByNavigationTab")!
  const _component_StatisticsViewsCountTabs = _resolveComponent("StatisticsViewsCountTabs")!

  return (_openBlock(), _createBlock(_component_StatisticsViewsCountTabs, null, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPortalViewsCountByTimeTab, { filter: _ctx.filter }, null, 8, ["filter"])
    ]),
    "second-tab": _withCtx(() => [
      _createVNode(_component_StatisticsPortalViewsCountByNavigationTab, { filter: _ctx.filter }, null, 8, ["filter"])
    ]),
    _: 1
  }))
}